import { useEffect, useRef, useState } from "react";
import { getTimerValuesFn } from "../utils/getTimerValuesFn";
import { TimeItem, TimeType, WrapperTimer, WrapperTimerItem } from "./Timer.styled";

export const Timer = ({time, id, onTimeFinish, points, isOnBreakTimer, onTimeUsed}) => {
  const [count, setCount] = useState(() => JSON.parse(localStorage.getItem(`timer-${id}`)) || time * 60);
  const [delayFormated, setDelayFormated] = useState(() => getTimerValuesFn(count * 1000)); 
  const intervalIdRef = useRef(null);
  
  const handleBreakTimer = () => {
    if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
      }
  }

  const handleStartTimer = () => {
    if (!intervalIdRef.current) {
      const newIntervalId = setInterval(() => {
        setCount(prev => prev - 1);
      }, 1000);
      intervalIdRef.current = newIntervalId;
    }
  }
  
  useEffect(() => {
    handleStartTimer();
    return handleBreakTimer;
  }, []);

  useEffect(() => {
    if (isOnBreakTimer) {
      handleBreakTimer();  
    } else {
      handleStartTimer();
    }
  }, [isOnBreakTimer]);

  useEffect(() => {
    if (points || points === 0) {
      handleBreakTimer();
      const timeUsed = getTimerValuesFn((time * 60 - count)*1000);
      onTimeUsed(timeUsed);
    }
  }, [points]);

  useEffect(() => {
    localStorage.setItem(`timer-${id}`, JSON.stringify(count));
    const delayObj = getTimerValuesFn(count * 1000);
    setDelayFormated({ ...delayObj });
  }, [count])
  
  useEffect(() => {
    if (count <= 0) {
      onTimeFinish();
      handleBreakTimer();
    }
  }, [count]);



  return (
<WrapperTimer>    
        <WrapperTimerItem>
             <TimeItem>{delayFormated.hours}</TimeItem>
             <TimeType>ora</TimeType>
             </WrapperTimerItem>
        
           <WrapperTimerItem>
             <TimeItem>{delayFormated.minutes}</TimeItem>
             <TimeType>minuti</TimeType>
           </WrapperTimerItem>
               
           <WrapperTimerItem>
             <TimeItem>{delayFormated.seconds}</TimeItem>
             <TimeType>secondi</TimeType>
      </WrapperTimerItem>
         </WrapperTimer> 
);
}


